/**
 * Shared map of translated site hostnames to their locale code.
 * Centralizes the allowed-hosts list used to detect the current
 * translated site and to build localized links to jsheld.com.
 */
var LOCALE_BY_HOST = {
    'es.jsheld.com': 'es',
    'fr.jsheld.com': 'fr'
};

var LocaleHost = {

    // returns the locale code for a given hostname, or null if it's not a known translated host
    getLocale: function(hostname){
        return LOCALE_BY_HOST[hostname] || null;
    },

    // returns true if the given hostname is one of our known translated hosts
    isAllowedHost: function(hostname){
        return Object.prototype.hasOwnProperty.call(LOCALE_BY_HOST, hostname);
    },

    // given a jsheld.com url and a target locale hostname, returns the localized version of that url
    // if the url's hostname doesn't already match the target locale hostname
    localizeUrl: function(url, localeHostname){
        var urlHostname = new URL(url, window.location.origin).hostname;

        if (urlHostname === localeHostname)
        {
            return url;
        }

        return url.replace('jsheld.com', localeHostname);
    }

};

export default LocaleHost;
